// Copyright (c) 2021. Heusala Group Oy <info@heusalagroup.fi>. All rights reserved.

import { ProductTableItemModel } from "../../../../../../io/hyperify/core/store/types/product/ProductTableItemModel";
import {
    T_COMMON_PRICE_WITH_PERIOD_EUR,
    T_COMMON_PRICE_EUR_LINE_2,
    T_DISCOUNT_PRICE_WITH_PERIOD_EUR,
    T_DISCOUNT_PRICE_EUR_LINE_2,
    T_DISCOUNT_PRICE_EUR_LINE_3,
    T_DISCOUNT_ORIGINAL_PRICE_WITH_PERIOD_EUR,
    T_DISCOUNT_ORIGINAL_PRICE_EUR_LINE_2,
    T_DATE_TIME_FORMAT
} from "../../../../core/constants/translation";
import { PRODUCT_TABLE_ITEM_HEADER_CLASS_NAME } from "../../../../core/constants/className";
import {
    ProductPriceType
} from "../../../../../../io/hyperify/core/store/types/product/ProductPriceType";
import { SendanorProductUtils } from "../../../../core/utils/SendanorProductUtils";
import { BuyButton } from "../buyButton/BuyButton";
import { TranslationFunction } from "../../../../../../io/hyperify/core/types/TranslationFunction";
import "./ProductTableItemHeader.scss";

export interface ProductTableItemProps {
    readonly t: TranslationFunction;
    readonly className?: string;
    readonly buttonLabel?: string;
    readonly disableBuyButton?: boolean;
    readonly item: ProductTableItemModel;
    readonly priceTypeOptions ?: ProductPriceType[];
    readonly setPriceType     ?: (value: ProductPriceType) => void;
    readonly dark ?: boolean;
}

export function ProductTableItemHeader (props: ProductTableItemProps) {

    const t = props?.t;
    const dark = props?.dark ?? false;
    const className = props?.className;
    const item: ProductTableItemModel = props?.item;
    const buttonLabel = props?.buttonLabel;
    const disableBuyButton : boolean = !!props?.disableBuyButton;
    const dateTimeFormat = t(T_DATE_TIME_FORMAT);

    const translationParams = SendanorProductUtils.createTranslationParamsFromPrice(
        item?.priceModel,
        dateTimeFormat,
        t,
    );

    return (
        <th className={`${
            PRODUCT_TABLE_ITEM_HEADER_CLASS_NAME
            + (className?' '+className:'')
            + (dark ? ' ' + PRODUCT_TABLE_ITEM_HEADER_CLASS_NAME + '-dark' : '')
        }`}>

            {item?.title ? (
                <p className={`${PRODUCT_TABLE_ITEM_HEADER_CLASS_NAME}-title`}>{t(item.title ?? "")}</p>
            ) : null}

            {item?.description ? (
                <div className={`${PRODUCT_TABLE_ITEM_HEADER_CLASS_NAME}-description`}>{t(item.description ?? "")}</div>
            ) : null}

            {item?.gb ? <div className={`${PRODUCT_TABLE_ITEM_HEADER_CLASS_NAME}-gb`}>{item.gb}</div> : null}

            {item?.price ? (
                <div className={`${PRODUCT_TABLE_ITEM_HEADER_CLASS_NAME}-price`}>

                    {!translationParams?.DISCOUNT ? (

                        <div className={`${PRODUCT_TABLE_ITEM_HEADER_CLASS_NAME}-price-description`}>{t(
                            T_COMMON_PRICE_WITH_PERIOD_EUR,
                            translationParams
                        )}<br />{t(
                            T_COMMON_PRICE_EUR_LINE_2,
                            translationParams
                        )}</div>

                    ) : (
                        <>

                            <div className={`${PRODUCT_TABLE_ITEM_HEADER_CLASS_NAME}-price-description-discount`}>{t(
                                T_DISCOUNT_PRICE_WITH_PERIOD_EUR,
                                translationParams
                            )}<br />{t(
                                T_DISCOUNT_PRICE_EUR_LINE_2,
                                translationParams
                            )}</div>

                            <div className={`${PRODUCT_TABLE_ITEM_HEADER_CLASS_NAME}-price-description-original`}>{t(
                                T_DISCOUNT_ORIGINAL_PRICE_WITH_PERIOD_EUR,
                                translationParams
                            )}<br />{t(
                                T_DISCOUNT_ORIGINAL_PRICE_EUR_LINE_2,
                                translationParams
                            )}</div>

                            <div className={`${PRODUCT_TABLE_ITEM_HEADER_CLASS_NAME}-price-description-discount`}>
                                <br />{t(
                                T_DISCOUNT_PRICE_EUR_LINE_3,
                                translationParams
                            )}</div>

                        </>
                    )}

                </div>
            ) : null}
            {item?.isButton && !disableBuyButton ? (
                <div>
                    {item.productModel && item.priceModel ? (
                        <BuyButton
                            product={item.productModel}
                            price={item.priceModel}
                        >{t(`${buttonLabel}`) ?? 'no text'}</BuyButton>
                    ) : null}
                </div>
            ) : null}
        </th>
    );
}
